import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import type { Prescription } from "@dearbill/shared";
import { HomeCard } from "./HomeCard";

/** "drugName (label)"; a blank `label` falls back to "drugName — form", then to the bare name. */
function medicationName(p: Prescription): string {
  if (p.label.trim()) return `${p.drugName} (${p.label})`;
  return p.form.trim() ? `${p.drugName} — ${p.form}` : p.drugName;
}

/** The latest enrollment's prescriptions in list order, names only, with "See all" to My Medications. */
export function MedicationsCard({ prescriptions }: { prescriptions: Prescription[] }): ReactNode {
  return (
    <HomeCard
      title="My Medications"
      titleSize="lg"
      action={
        <Link
          to="/medications"
          className="text-link text-primary-text hover:text-ember-dark shrink-0 hover:underline"
        >
          See all
        </Link>
      }
    >
      {prescriptions.length === 0 ? (
        <p className="text-body-sm text-slate-teal">
          {"Your medications will appear here once they're added to your enrollment."}
        </p>
      ) : (
        <ul className="text-body-sm text-midnight flex flex-col gap-3 font-semibold">
          {prescriptions.map((p) => (
            <li key={p.rxcui}>{medicationName(p)}</li>
          ))}
        </ul>
      )}
    </HomeCard>
  );
}
